var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ContactSection"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"ContactTitle",domProps:{"innerHTML":_vm._s(_vm.acf.title.rendered)}}),_c('p',{staticClass:"WhiteStandard-text contact-width",domProps:{"innerHTML":_vm._s(_vm.acf.content.rendered)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }